import Repository from "@shared/services/api/abstracts/Repository";
import { UrlRouteMap } from "@shared/services/api/types";
import { venueBasedUrl } from "@shared/services/api/utils/RepositoryUrlUtils";
import { AxiosRequestConfig } from "axios";
import {
  GetMembershipGroupStatsParamsType,
  VenueBasedMembershipGroupDailyStat,
  VenueBasedMembershipGroupSerializer,
  VenueBasedMembershipGroupStatsSerializer,
} from "../types/membership-groups";

export default class VenueBasedMembershipGroupRepository extends Repository<VenueBasedMembershipGroupSerializer> {
  public readonly repositoryName = "VenueBasedMembershipGroupRepository";

  public readonly endpoint = venueBasedUrl("memberships/membership-groups/");

  public get urlMap(): UrlRouteMap {
    return {
      ...this.defaultUrlMap,
      dailyScanStats: "stats/daily-scan",
      stats: "stats",
    };
  }

  public async dailyScanStats(
    config: AxiosRequestConfig = {}
  ): Promise<Array<VenueBasedMembershipGroupDailyStat>> {
    const { data } = await this.request<
      Array<VenueBasedMembershipGroupDailyStat>
    >(this.buildUrl("dailyScanStats"), config);
    return data;
  }

  public async stats(
    attributes: GetMembershipGroupStatsParamsType,
    config: AxiosRequestConfig = {}
  ): Promise<VenueBasedMembershipGroupStatsSerializer> {
    const { data } =
      await this.request<VenueBasedMembershipGroupStatsSerializer>(
        this.buildUrl("stats"),
        {
          method: "get",
          data: attributes,
          ...config,
        }
      );
    return data;
  }
}
